import NextImage from "@/app/components/lib/NextImage";
import { Link as ScrollLink } from "react-scroll";
import TabsSlider from "../../../lib/Embla-tabs-slider/TabsSlider";

type tab = {
  name: string;
  icon_src: string;
  id: number;
};
interface props {
  tabs: tab[];
  activeTab: number;
  setActiveTab: (tab: number) => void;
  viewIcons: boolean;
}
const ProductTabsCarousel: React.FC<props> = ({
  tabs,
  activeTab,
  setActiveTab,
  viewIcons,
}) => {
  const TsScrollLink: any = ScrollLink;
  return (
    <TabsSlider spacing={6} selectedIndex={activeTab}>
      {tabs.map((tab, index) => (
        <div
          className={`pop-up-tab text-nowrap ${
            activeTab === index ? "selected" : ""
          }`}
          key={index}
        >
          <TsScrollLink
            className={`pop-up-tab text-nowrap tab-link ${
              activeTab === index ? "selected" : ""
            }`}
            activeClass="pop-up-tab text-nowrap tab-link selected"
            spy
            to={tab.name}
            offset={-200}
            onSetActive={() => setActiveTab(index)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 4,
              }}
            >
              {viewIcons && (
                <NextImage
                  width={18}
                  height={18}
                  src={tab.icon_src}
                  alt={"tab"}
                  style={{ borderRadius: 9 }}
                />
              )}
              <div> {tab.name}</div>
            </div>
          </TsScrollLink>
        </div>
      ))}
    </TabsSlider>
  );
};
export default ProductTabsCarousel;
